export const en = {
  'dashboards.title': 'Charts',
  'dashboards.description': 'Charts built from the gym’s own data. Choose the chart, the data and its size.',
  'dashboards.board': 'Board',
  'dashboards.suggested': 'Suggested for you',
  'dashboards.suggestedHint': 'A starting board for your role. Customise it to make it your own: add, remove, resize and reorder charts.',
  'dashboards.customise': 'Customise',
  'dashboards.newBoard': 'New board',
  'dashboards.edit': 'Edit charts',
  'dashboards.done': 'Done',
  'dashboards.settings': 'Board settings',
  'dashboards.addChart': 'Add a chart',
  'dashboards.editChart': 'Edit chart',
  'dashboards.duplicateChart': 'Duplicate chart',
  'dashboards.removeChart': 'Remove chart',
  'dashboards.moveEarlier': 'Move earlier',
  'dashboards.moveLater': 'Move later',
  'dashboards.dragToMove': 'Drag to move',
  'dashboards.period': 'Period',
  'dashboards.eachOwnPeriod': 'Each chart’s own period',
  'dashboards.name': 'Name',
  'dashboards.visibility': 'Who sees it',
  'dashboards.onlyMe': 'Only me',
  'dashboards.everyone': 'Everyone who can open this page',
  'dashboards.shared': 'Shared',
  'dashboards.private': 'Private',
  'dashboards.readOnly': 'Made by {name}. Only they, an owner or an admin can change it.',
  'dashboards.copyToMine': 'Copy to my boards',
  'dashboards.delete': 'Delete board',
  'dashboards.deleteTitle': 'Delete this board?',
  'dashboards.deleteDescription': '“{name}” is removed for everyone who could see it. The data behind its charts stays.',
  'dashboards.saved': 'Board saved',
  'dashboards.updated': 'Board updated',
  'dashboards.deleted': 'Board deleted',
  'dashboards.emptyTitle': 'No charts on this board yet',
  'dashboards.emptyDescription': 'Add a chart: choose its type, its data and its size.',
  'dashboards.problems': 'Some charts on this board no longer match the data rules and are hidden: {problems}',
  'dashboards.defaultName': 'My charts',
  'dashboards.copyName': '{name} (copy)',
  'dashboards.chart.column': 'Columns',
  'dashboards.chart.bar': 'Bars',
  'dashboards.chart.line': 'Line',
  'dashboards.chart.area': 'Area',
  'dashboards.chart.stacked_column': 'Stacked columns',
  'dashboards.chart.grouped_column': 'Grouped columns',
  'dashboards.chart.donut': 'Donut',
  'dashboards.chart.pie': 'Pie',
  'dashboards.chart.number': 'Number',
  'dashboards.chart.table': 'Table',
  'dashboards.chartHint.column': 'One value per period or category',
  'dashboards.chartHint.bar': 'Categories ranked, long names fit',
  'dashboards.chartHint.line': 'A trend over time',
  'dashboards.chartHint.area': 'A trend and its volume',
  'dashboards.chartHint.stacked_column': 'A total and what makes it up',
  'dashboards.chartHint.grouped_column': 'Series side by side',
  'dashboards.chartHint.donut': 'Shares of a whole',
  'dashboards.chartHint.pie': 'Shares of a whole',
  'dashboards.chartHint.number': 'One figure and its change',
  'dashboards.chartHint.table': 'Every number, in rows',
  'dashboards.editor.addTitle': 'Add a chart',
  'dashboards.editor.editTitle': 'Edit chart',
  'dashboards.editor.type': 'Chart type',
  'dashboards.editor.title': 'Title',
  'dashboards.editor.titlePlaceholder': 'Named after its data',
  'dashboards.editor.plot': 'Plot',
  'dashboards.editor.width': 'Width',
  'dashboards.editor.height': 'Height',
  'dashboards.editor.preview': 'Preview',
  'dashboards.editor.save': 'Save chart',
  'dashboards.width.3': 'Quarter',
  'dashboards.width.4': 'Third',
  'dashboards.width.6': 'Half',
  'dashboards.width.8': 'Two thirds',
  'dashboards.width.12': 'Full width',
  'dashboards.editor.columns': '{count} of 12 columns',
  'dashboards.editor.rows': '{count} rows',
  'dashboards.editor.tint': 'Title colour',
  'dashboards.tint.white': 'White',
  'dashboards.tint.blue': 'Blue',
  'dashboards.tint.teal': 'Teal',
  'dashboards.tint.green': 'Green',
  'dashboards.tint.yellow': 'Yellow',
  'dashboards.tint.orange': 'Orange',
  'dashboards.tint.pink': 'Pink',
  'dashboards.tint.purple': 'Purple',
  'dashboards.resize': 'Resize chart',
  'dashboards.resizeHint': 'Drag the corner, or use the arrow keys: left and right change the width, up and down the height.',
  'dashboards.size': '{width} of 12 columns · {height} rows',
  'dashboards.problem.twoGroupings': 'This chart needs a second grouping for its series: choose one under “Then by”.',
  'dashboards.problem.oneGrouping': 'This chart plots one grouping: set “Then by” to nothing.',
  'dashboards.problem.ordered': 'A line or an area runs along time: group by day, week, month, quarter or weekday first.',
  'dashboards.problem.categorical': 'A donut or a pie shows parts of a whole: group by a category, not a period.',
  'dashboards.problem.sums': 'Averages and rates do not add up to a whole: plot the amount or the count.',
  'dashboards.problem.measure': 'Tick the plotted value under “Show”.',
  'dashboards.widget.noAccess': 'Not available for your role',
  'dashboards.widget.noAccessHint': 'This chart shows money, which only finance roles can read.',
  'dashboards.widget.error': 'This chart could not be drawn',
  'dashboards.widget.empty': 'Nothing in this period',
  'dashboards.widget.truncated': 'The largest {count} rows are shown.',
  'dashboards.autoTitle.byOne': '{measure} by {group}',
  'dashboards.autoTitle.byTwo': '{measure} by {group} and {then}',
  'dashboards.autoTitle.total': '{measure}',
  'dashboards.previousValue': '{name} · {period}',
  'dashboards.downloadPdf': 'PDF',
  'dashboards.downloadPptx': 'PowerPoint',
  'dashboards.downloadAsPdf': 'Download the board as a PDF',
  'dashboards.downloadAsPptx': 'Download the board as a PowerPoint deck with editable charts',
  'dashboards.downloadedOn': '{gym} · downloaded {date}',
  'dashboards.pageOf': 'Page {page} of {count}',
  'dashboards.downloadFailed': 'The file could not be made',
};

export const ka: Record<keyof typeof en, string> = {
  'dashboards.title': 'დიაგრამები',
  'dashboards.description': 'დიაგრამები დარბაზის საკუთარი მონაცემებით. აირჩიეთ დიაგრამა, მონაცემები და ზომა.',
  'dashboards.board': 'დაფა',
  'dashboards.suggested': 'შემოთავაზებული',
  'dashboards.suggestedHint': 'საწყისი დაფა თქვენი როლისთვის. მოირგეთ: დაამატეთ, წაშალეთ, შეცვალეთ ზომა და რიგითობა.',
  'dashboards.customise': 'მორგება',
  'dashboards.newBoard': 'ახალი დაფა',
  'dashboards.edit': 'დიაგრამების რედაქტირება',
  'dashboards.done': 'მზადაა',
  'dashboards.settings': 'დაფის პარამეტრები',
  'dashboards.addChart': 'დიაგრამის დამატება',
  'dashboards.editChart': 'დიაგრამის რედაქტირება',
  'dashboards.duplicateChart': 'დიაგრამის დუბლირება',
  'dashboards.removeChart': 'დიაგრამის წაშლა',
  'dashboards.moveEarlier': 'წინ გადატანა',
  'dashboards.moveLater': 'უკან გადატანა',
  'dashboards.dragToMove': 'გადასატანად გადაათრიეთ',
  'dashboards.period': 'პერიოდი',
  'dashboards.eachOwnPeriod': 'თითოეული დიაგრამის საკუთარი პერიოდი',
  'dashboards.name': 'სახელი',
  'dashboards.visibility': 'ვინ ხედავს',
  'dashboards.onlyMe': 'მხოლოდ მე',
  'dashboards.everyone': 'ყველა, ვისაც ეს გვერდი ეხსნება',
  'dashboards.shared': 'გაზიარებული',
  'dashboards.private': 'პირადი',
  'dashboards.readOnly': 'შექმნა {name}-მა. შეცვლა შეუძლია მხოლოდ მას, მფლობელს ან ადმინისტრატორს.',
  'dashboards.copyToMine': 'ჩემს დაფებში კოპირება',
  'dashboards.delete': 'დაფის წაშლა',
  'dashboards.deleteTitle': 'წავშალოთ ეს დაფა?',
  'dashboards.deleteDescription': '„{name}“ წაიშლება ყველასთვის, ვინც მას ხედავდა. დიაგრამების მონაცემები უცვლელი რჩება.',
  'dashboards.saved': 'დაფა შენახულია',
  'dashboards.updated': 'დაფა განახლდა',
  'dashboards.deleted': 'დაფა წაიშალა',
  'dashboards.emptyTitle': 'ამ დაფაზე დიაგრამები ჯერ არ არის',
  'dashboards.emptyDescription': 'დაამატეთ დიაგრამა: აირჩიეთ ტიპი, მონაცემები და ზომა.',
  'dashboards.problems': 'ამ დაფის ზოგიერთი დიაგრამა აღარ შეესაბამება მონაცემების წესებს და დამალულია: {problems}',
  'dashboards.defaultName': 'ჩემი დიაგრამები',
  'dashboards.copyName': '{name} (ასლი)',
  'dashboards.chart.column': 'სვეტები',
  'dashboards.chart.bar': 'ზოლები',
  'dashboards.chart.line': 'ხაზი',
  'dashboards.chart.area': 'არე',
  'dashboards.chart.stacked_column': 'დაწყობილი სვეტები',
  'dashboards.chart.grouped_column': 'დაჯგუფებული სვეტები',
  'dashboards.chart.donut': 'რგოლი',
  'dashboards.chart.pie': 'ტორტი',
  'dashboards.chart.number': 'რიცხვი',
  'dashboards.chart.table': 'ცხრილი',
  'dashboards.chartHint.column': 'ერთი მნიშვნელობა პერიოდის ან კატეგორიის მიხედვით',
  'dashboards.chartHint.bar': 'კატეგორიები რიგით, გრძელი სახელებიც ეტევა',
  'dashboards.chartHint.line': 'ტენდენცია დროში',
  'dashboards.chartHint.area': 'ტენდენცია და მისი მოცულობა',
  'dashboards.chartHint.stacked_column': 'ჯამი და მისი შემადგენელი ნაწილები',
  'dashboards.chartHint.grouped_column': 'სერიები გვერდიგვერდ',
  'dashboards.chartHint.donut': 'მთლიანის წილები',
  'dashboards.chartHint.pie': 'მთლიანის წილები',
  'dashboards.chartHint.number': 'ერთი მაჩვენებელი და მისი ცვლილება',
  'dashboards.chartHint.table': 'ყველა რიცხვი, სტრიქონებად',
  'dashboards.editor.addTitle': 'დიაგრამის დამატება',
  'dashboards.editor.editTitle': 'დიაგრამის რედაქტირება',
  'dashboards.editor.type': 'დიაგრამის ტიპი',
  'dashboards.editor.title': 'სათაური',
  'dashboards.editor.titlePlaceholder': 'მონაცემების მიხედვით დასახელებული',
  'dashboards.editor.plot': 'ასახვა',
  'dashboards.editor.width': 'სიგანე',
  'dashboards.editor.height': 'სიმაღლე',
  'dashboards.editor.preview': 'გადახედვა',
  'dashboards.editor.save': 'დიაგრამის შენახვა',
  'dashboards.width.3': 'მეოთხედი',
  'dashboards.width.4': 'მესამედი',
  'dashboards.width.6': 'ნახევარი',
  'dashboards.width.8': 'ორი მესამედი',
  'dashboards.width.12': 'სრული სიგანე',
  'dashboards.editor.columns': '{count} სვეტი 12-დან',
  'dashboards.editor.rows': '{count} რიგი',
  'dashboards.editor.tint': 'სათაურის ფერი',
  'dashboards.tint.white': 'თეთრი',
  'dashboards.tint.blue': 'ცისფერი',
  'dashboards.tint.teal': 'ფირუზისფერი',
  'dashboards.tint.green': 'მწვანე',
  'dashboards.tint.yellow': 'ყვითელი',
  'dashboards.tint.orange': 'ნარინჯისფერი',
  'dashboards.tint.pink': 'ვარდისფერი',
  'dashboards.tint.purple': 'იისფერი',
  'dashboards.resize': 'დიაგრამის ზომის შეცვლა',
  'dashboards.resizeHint': 'გადაათრიეთ კუთხე ან გამოიყენეთ ისრები: მარცხნივ და მარჯვნივ იცვლება სიგანე, ზემოთ და ქვემოთ — სიმაღლე.',
  'dashboards.size': '{width} სვეტი 12-დან · {height} რიგი',
  'dashboards.problem.twoGroupings': 'ამ დიაგრამას სერიებისთვის მეორე დაჯგუფება სჭირდება: აირჩიეთ „შემდეგ“ ველში.',
  'dashboards.problem.oneGrouping': 'ეს დიაგრამა ერთ დაჯგუფებას ასახავს: „შემდეგ“ ველში აირჩიეთ „არაფერი“.',
  'dashboards.problem.ordered': 'ხაზი ან არე დროის მიხედვით მიდის: ჯერ დააჯგუფეთ დღის, კვირის, თვის, კვარტლის ან კვირის დღის მიხედვით.',
  'dashboards.problem.categorical': 'რგოლი ან ტორტი მთლიანის ნაწილებს აჩვენებს: დააჯგუფეთ კატეგორიით და არა პერიოდით.',
  'dashboards.problem.sums': 'საშუალოები და პროცენტები მთლიანს არ ქმნის: ასახეთ თანხა ან რაოდენობა.',
  'dashboards.problem.measure': 'მონიშნეთ ასასახი მნიშვნელობა „ჩვენება“ ველში.',
  'dashboards.widget.noAccess': 'თქვენი როლისთვის მიუწვდომელია',
  'dashboards.widget.noAccessHint': 'ეს დიაგრამა ფულს აჩვენებს, რასაც მხოლოდ ფინანსური როლები ხედავს.',
  'dashboards.widget.error': 'დიაგრამის აგება ვერ მოხერხდა',
  'dashboards.widget.empty': 'ამ პერიოდში არაფერია',
  'dashboards.widget.truncated': 'ნაჩვენებია უდიდესი {count} სტრიქონი.',
  'dashboards.autoTitle.byOne': '{measure} — {group} მიხედვით',
  'dashboards.autoTitle.byTwo': '{measure} — {group} და {then} მიხედვით',
  'dashboards.autoTitle.total': '{measure}',
  'dashboards.previousValue': '{name} · {period}',
  'dashboards.downloadPdf': 'PDF',
  'dashboards.downloadPptx': 'PowerPoint',
  'dashboards.downloadAsPdf': 'დაფის PDF-ად ჩამოტვირთვა',
  'dashboards.downloadAsPptx': 'დაფის PowerPoint-ის პრეზენტაციად ჩამოტვირთვა, რედაქტირებადი დიაგრამებით',
  'dashboards.downloadedOn': '{gym} · ჩამოტვირთულია {date}',
  'dashboards.pageOf': 'გვერდი {page} / {count}',
  'dashboards.downloadFailed': 'ფაილის შექმნა ვერ მოხერხდა',
};
